import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

// Tema aplicado antes do primeiro paint para evitar flash.
const saved = localStorage.getItem("oc-theme") as "light" | "dark" | "system" | null;
const theme =
  saved ??
  (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");
document.documentElement.dataset.theme = theme === "system" ? "light" : theme;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
